// extracted by mini-css-extract-plugin
module.exports = {"senior":"styles_senior__21dxq","regularPlus":"styles_regularPlus__3u7Fy","regular":"styles_regular__cR31L","juniorPlus":"styles_juniorPlus__2wnbb","junior":"styles_junior__1EOHo"};